// extracted by mini-css-extract-plugin
var _1 = "contactsCard-module__contactsCardButtons___Habnc";
var _2 = "contactsCard-module__contactsCardContainer___dCk0Y";
export { _1 as "contactsCardButtons", _2 as "contactsCardContainer" }
